var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.5H14C14.55 6.5 15 6.05 15 5.5C15 4.95 14.55 4.5 14 4.5H11C10.45 4.5 10 4.95 10 5.5C10 6.05 10.45 6.5 11 6.5ZM11 13.5H14C14.55 13.5 15 13.05 15 12.5C15 11.95 14.55 11.5 14 11.5H11C10.45 11.5 10 11.95 10 12.5C10 13.05 10.45 13.5 11 13.5ZM16 18H2C0.9 18 0 17.1 0 16V2C0 0.9 0.9 0 2 0H16C17.1 0 18 0.9 18 2V16C18 17.1 17.1 18 16 18ZM4 8H7C7.55 8 8 7.55 8 7V4C8 3.45 7.55 3 7 3H4C3.45 3 3 3.45 3 4V7C3 7.55 3.45 8 4 8ZM4 4H7V7H4V4ZM4 15H7C7.55 15 8 14.55 8 14V11C8 10.45 7.55 10 7 10H4C3.45 10 3 10.45 3 11V14C3 14.55 3.45 15 4 15ZM4 11H7V14H4V11Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveys);
export default __webpack_public_path__ + "static/media/surveys.09f0a63c81844ac4f40da2fa956c1351.svg";
export { ForwardRef as ReactComponent };